
export interface ShakingData {
    duration: number;
    repeats: number;
    min: number;
    max: number;
}

/**
 * Override these values in game if needed.
 */

export const PICK_CONSTANTS = {
    ITEMS_AMOUNT: 12,
    ALIGN_CONTAINER_X: 0.5,
    ALIGN_CONTAINER_Y: 0.5,
    SCALE_CONTAINER_X: 0.25,
    SCALE_CONTAINER_Y: 0.25,
    TOTAL_WIN_AMOUNT: 3,
    FADE_OUT_TIMER: 2000,
    REVEAL_UN_OPENED_DELAY: 500,
    AWARD_DELAY: 2000,
    SHEEN_DELAY: 5000,
    PICK_BACK_ANIMATION_Y: 860,
    START_DELAY: 1000,
    SHAKING_DATA: {
        duration: 250,
        repeats: 2,
        min: -130,
        max: 130
    },
    PICK_BONUS_TEXT_SLOT_NAME: 'messaging_txt',
    PICK: 'pick',
    BONUS_PICK_JPCOINS: 'bonus_pick_jpcoins',
    MULTI_: 'multi_',
    WIN: 'win',
    JP_COIN: 'jp_coin',
    MINI: 'mini',
    MINOR: 'minor',
    MAJOR: 'major',
    GRAND: 'grand',
    BONUS_PICK_COIN_SHEEN: 'bonus_pick_coin_sheen',
    BONUS_PICK_COIN_FLY: 'bonus_pick_coins_fly',
    TOP_TO_BOTTOM: 'top_to_bottom',
    FEATURE_PICK: 'feature_pick',
    BACKGROUND_LOOP: 'background_loop',
    BACKGROUND_APPEAR: 'background_appear',
    SLOT_NAME: 'multiplayer_3x',
    COIN_SHEEN: 'coin_sheen',
    COIN_: 'coin_',
    ANIMATION: 'animation',
    JACKPOTPICK: 'jackpotpick',
    COINREVEAL: 'coinreveal',
    COINREVEALMULTI: 'coinrevealmulti',
    PICKPRIZEWON: 'pickprizewon',
};
